<template>
  <!-- 页面名称 -->
  <div class="Box">
    <el-form class="selectClass">
      <el-row :gutter="20" style="display: flex;align-items: center">
        <el-col :span="5">
          <!-- 邮编所属州 -->
          <el-form-item :label="$t('collectionCenter.postalCodeState')">
            <el-select
              v-model="queryForm.params.state"
              :placeholder="$t('collectionCenter.pleaseChoose')"
              clearable
              filterable
              size="small"
              style="width: 100%"
              @change="getCity"
            >
              <el-option
                v-for="(item, index) in twoCodeList"
                :key="index"
                :label="item.shortName"
                :value="item.shortName"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <!-- 邮编所属城市 -->
          <el-form-item :label="$t('collectionCenter.postalCodeCity')">
            <el-select
              v-model="queryForm.params.city"
              :placeholder="$t('collectionCenter.pleaseChoose')"
              clearable
              filterable
              size="small"
              style="width: 100%"
            >
              <el-option
                v-for="(item, index) in allCity"
                :key="index"
                :label="item.name"
                :value="item.name"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <!-- 邮编 -->
          <el-form-item :label="$t('collectionCenter.Zip')">
            <el-input v-model.trim="queryForm.params.zipCode" size="small" clearable :placeholder="$t('collectionCenter.input8ZipCode')" />
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <!-- 区域类型 -->
          <el-form-item :label="$t('collectionCenter.regionType')">
            <el-select
              v-model="queryForm.params.areaType"
              :placeholder="$t('collectionCenter.pleaseChoose')"
              clearable
              filterable
              size="small"
              style="width: 100%"
            >
              <el-option label="CAP" value="CAP" />
              <el-option label="INT" value="INT" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" size="small" @click="search">{{ $t('newOrder.search') }}</el-button>

          <el-button type="info" size="small" @click="reset">{{ $t('collectionCenter.reset') }}</el-button>
        </el-col>
      </el-row>
    </el-form>
    <el-divider />
    <div style="margin-bottom: 10px;">
      <el-button
        v-permit:remove="'btn:basic-data:postal-code-management:add'"
        icon="el-icon-plus" size="small"
        type="primary" @click="newAdd"
      >
        {{ $t('GlobalSetObj.add') }}
      </el-button>
      <el-button
        v-permit:remove="'btn:basic-data:postal-code-management:import'"
        size="small" @click="importThis"
      >
        {{ $t('collectionCenter.Import') }}
      </el-button>
      <el-button
        v-permit:remove="'btn:basic-data:postal-code-management:allExport'"
        size="small" type="primary" @click="exportAll"
      >
        {{ $t('collectionCenter.allExport') }}
      </el-button>
    </div>
    <el-table
      ref="tableRef"
      border
      :data="tableDate"
      :max-height="600"
    >
      <el-table-column
        type="selection"
        width="55"
      />
      <!-- 序号 -->
      <el-table-column
        :label="$t('collectionCenter.ind')" type="index" width="60"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ (queryForm.pageNumber - 1) * queryForm.pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="state"
        align="center"
        :label="$t('collectionCenter.state')"
      /><!-- 州 -->
      <el-table-column
        prop="city"
        align="center"
        :label="$t('collectionCenter.city')"
      /><!-- 城市 -->
      <el-table-column
        prop="startZipCodeStr"
        align="center"
        :label="$t('collectionCenter.startZipCode')"
      /><!-- 起始邮编 -->
      <el-table-column
        prop="endZipCodeStr"
        align="center"
        :label="$t('collectionCenter.endZipCode')"
      /><!-- 结束邮编 -->
      <el-table-column
        prop="areaType"
        align="center"
        :label="$t('collectionCenter.regionType')"
      /><!-- 区域类型 -->
      <el-table-column
        :label="$t('GlobalSetObj.LatestModifiedBy')"
        prop="updateUserName"
        align="center"
      /><!-- 最新修改人 -->
      <el-table-column
        :label="$t('GlobalSetObj.LastModified')"
        prop="updateTime"
        align="center"
      /><!-- 最新修改时间 -->
      <el-table-column
        :label="$t('collectionCenter.operation')"
        fixed="right"
        align="center"
      >
        <template slot-scope="scope">
          <el-tooltip
            :content="$t('GlobalSetObj.edit')" class="item" effect="dark"
            placement="top"
          >
            <el-button
              v-permit:remove="'btn:basic-data:postal-code-management:edit'"
              size="mini"
              style="color: #666; margin-right: 10px"
              type="text"
              @click="edit(scope.row)"
            >
              <i class="el-icon-edit-outline" style="font-size: 20px;" />
            </el-button>
          </el-tooltip>

          <el-tooltip
            :content="$t('GlobalSetObj.Delete')" class="item" effect="dark"
            placement="top"
          >
            <el-popconfirm
              :title="$t('collectionCenter.deleteSure')"
              @confirm="tableDel(scope.row.id)"
            ><!-- 确定删除吗？ -->
              <i
                slot="reference" v-permit:remove="'btn:basic-data:postal-code-management:del'"
                class="el-icon-delete" style="font-size: 20px;"
              />
            </el-popconfirm>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <div class="right">
      <el-pagination
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="queryForm.pageNumber"
        :page-sizes="[10, 20, 50, 100]"
        :page-size.sync="queryForm.pageSize"
        :total="total"
        background
        style="margin: 10px 0"
        @current-change="search"
        @size-change="search1"
      />
    </div>
    <!-- 新增 / 编辑 窗口 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogIsOpen"
      width="60%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="cloceDialog"
    >
      <el-form ref="formRef" :model="postalCodeList">
        <el-row>
          <el-col :span="24">
            <!-- 州 -->
            <el-form-item
              :label="$t('collectionCenter.state')" prop="state"
              :rules="[
                { required: true, message: $t('collectionCenter.notNull'), trigger: ['blur', 'change'] }
              ]"
            >
              <el-select
                v-model="postalCodeList.state"
                :placeholder="$t('collectionCenter.pleaseChoose')"
                clearable
                filterable
                style="width: 100%"
                @change="getCity"
              >
                <el-option
                  v-for="(item, index) in twoCodeList"
                  :key="index"
                  :label="item.shortName"
                  :value="item.shortName"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <!-- 城市 -->
            <el-form-item
              :label="$t('collectionCenter.city')" prop="city"
              :rules="[
                { required: true, message: $t('collectionCenter.notNull'), trigger: ['blur', 'change'] }
              ]"
            >
              <el-select
                v-model="postalCodeList.city"
                :placeholder="$t('collectionCenter.pleaseChoose')"
                clearable
                filterable
                style="width: 100%"
              >
                <el-option
                  v-for="(item, index) in allCity"
                  :key="index"
                  :label="item.name"
                  :value="item.name"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-table
              border
              :data="postalCodeList.zipCodeList || []" style="width: 100%; margin-top: 15px;"
            >
              <el-table-column prop="startZipCodeStr" :label="$t('collectionCenter.startZipC')" align="center">
                <template slot-scope="scope">
                  <el-form-item
                    :prop="'zipCodeList.' + scope.$index + '.startZipCodeStr'"
                    :rules="[
                      { required: true, message: $t('collectionCenter.notNull'), trigger: ['blur', 'change'] },
                      { validator: (rule, value, callback) => validateZipCode(rule, value, callback, scope.$index) }
                    ]"
                  >
                    <el-input v-model.trim="scope.row.startZipCodeStr" clearable :placeholder="$t('collectionCenter.input8ZipCode')" />
                  </el-form-item>
                </template>
              </el-table-column>

              <el-table-column prop="endZipCodeStr" :label="$t('collectionCenter.endZipCode')" align="center">
                <template slot-scope="scope">
                  <el-form-item
                    :prop="'zipCodeList.' + scope.$index + '.endZipCodeStr'"
                    :rules="[
                      { required: true, message: $t('collectionCenter.notNull'), trigger: ['blur', 'change'] },
                      { validator: (rule, value, callback) => validateZipCode(rule, value, callback, scope.$index) }
                    ]"
                  >
                    <el-input v-model.trim="scope.row.endZipCodeStr" clearable :placeholder="$t('collectionCenter.input8ZipCode')" />
                  </el-form-item>
                </template>
              </el-table-column>

              <el-table-column prop="areaType" :label="$t('collectionCenter.regionType')" align="center">
                <template slot-scope="scope">
                  <el-form-item
                    :prop="'zipCodeList.' + scope.$index + '.areaType'"
                    :rules="[
                      { required: true, message: $t('collectionCenter.notNull'), trigger: ['blur', 'change'] }
                    ]"
                  >
                    <el-select v-model="scope.row.areaType" :placeholder="$t('collectionCenter.pleaseChoose')" style="width: 100%">
                      <el-option label="CAP" value="CAP" />
                      <el-option label="INT" value="INT" />
                    </el-select>
                  </el-form-item>
                </template>
              </el-table-column>

              <el-table-column :label="$t('collectionCenter.operation')" align="center" width="80">
                <template slot-scope="scope">
                  <el-tooltip
                    :content="$t('GlobalSetObj.Delete')" class="item" effect="dark"
                    placement="top"
                  >
                    <el-popconfirm
                      :title="$t('collectionCenter.deleteSure')"
                      @confirm="removeRow(scope.$index)"
                    ><!-- 确定删除吗？ -->
                      <i slot="reference" class="el-icon-delete" />
                    </el-popconfirm>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
            <!-- 起始邮编不能大于结束邮编，且邮编不允许重复！ -->
            <span class="codeClass">{{ $t('collectionCenter.postalCodeValidation') }}</span>
            <!-- 添加按钮 -->
            <!-- (编辑窗口限制只能有一列输入邮编的) -->
            <div v-if="dialogTitle !== $t('collectionCenter.edit')" style="text-align: center; margin-top: 15px;">
              <el-button icon="el-icon-plus" type="primary" @click="addNewRow" />
            </div>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button type="info" @click="cloceDialog">{{ $t('collectionCenter.cancel') }}</el-button>
        <el-button type="primary" @click="submit">{{ $t('collectionCenter.confirm') }}</el-button>
      </span>
    </el-dialog>

    <!-- 导入窗口 -->
    <el-dialog
      :title="importTitle"
      :visible.sync="importIsOpen"
      width="45%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="cloceImportDialog"
    >
      <span class="import-title">{{ $t('collectionCenter.uploadPostalCodeFile') }}</span>
      <div class="upload-container">
        <el-upload
          ref="demoUpload"
          :before-upload="beforeUpload"
          :http-request="upLoad"
          :limit="1"
          action
          class="upload-demo"
          drag
        >
          <i class="el-icon-plus" style="margin: 25px auto 10px; font-size: 20px" />
          <!-- 点击或拖拽文件到此处上传 -->
          <div class="el-upload__text">{{ $t('collectionCenter.cldrUpload') }}</div>
        </el-upload>
      </div>
      <div style="font-size: 17px;margin: 20px 0 9px 50px">{{ $t('collectionCenter.importTemplateDownload') }}</div>
      <div class="templateDownloadClass" @click.stop="templateDownload">
        <span>{{ $t('collectionCenter.postalCodeTemplateDownload') }}</span>
        <span class="el-icon-download" />
      </div>

      <span slot="footer">
        <el-button type="info" size="small" @click="cloceImportDialog">{{ $t('collectionCenter.cancel') }}</el-button>
        <el-button type="primary" size="small" @click="submitImportFile">{{ $t('collectionCenter.submit') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  selectCity,
  selectState
} from '@/api/orderApi';
import {
  zipCodeManagePage,
  zipCodeManageAdd,
  zipCodeManageEdit,
  zipCodeManageDel,
  zipCodeManageExportAll,
  zipCodeManageImport
} from '@/api/lanshou';
import { Loading } from 'element-ui';
import { goRWExportList } from '@/utils/goExportList.js';
import { saveAs } from 'file-saver';
const ExcelJS = require('exceljs');

export default {
  name: 'PostalCodeManagement',
  data() {
    const validateZipCode = (rule, value, callback, index) => {
      const row = this.postalCodeList.zipCodeList[index];
      const { startZipCodeStr, endZipCodeStr } = row;
      // 1. 校验是否为8位纯数字
      if (
        (startZipCodeStr && !/^[0-9]{8}$/.test(startZipCodeStr)) ||
        (endZipCodeStr && !/^[0-9]{8}$/.test(endZipCodeStr))
      ) {
        return callback(new Error(this.$t('collectionCenter.input8ZipCode')));
      }
      // 2. 起始邮编不能大于结束邮编
      if (startZipCodeStr && endZipCodeStr && startZipCodeStr > endZipCodeStr) {
        return callback(new Error(this.$t('collectionCenter.zipCodeRangeSizePrompts')));
      }
      // 3. 邮编范围不能重复
      const exists = this.postalCodeList.zipCodeList.some((item, i) => {
        return i !== index &&
          ((startZipCodeStr >= item.startZipCodeStr && startZipCodeStr <= item.endZipCodeStr) ||
            (endZipCodeStr >= item.startZipCodeStr && endZipCodeStr <= item.endZipCodeStr));
      });
      if (exists) {
        return callback(new Error(this.$t('collectionCenter.noDuplicationAllowed')));
      }
      this.$refs.formRef.clearValidate();
      callback();
    };
    return {
      parsedDataList: [],
      validateZipCode: validateZipCode,
      twoCodeList: [],
      allCity: [],
      queryForm: {
        pageNumber: 1,
        pageSize: 10,
        params: {
          state: '',
          city: '',
          zipCode: '',
          areaType: ''
        }
      },
      total: 0,
      tableDate: [],
      dialogIsOpen: false,
      dialogTitle: '',
      postalCodeList: {
        state: '',
        city: '',
        zipCodeList: [
          { startZipCodeStr: '', endZipCodeStr: '', areaType: '' }
        ]
      },
      importTitle: this.$t('collectionCenter.Import'),
      importIsOpen: false,
      importFile: new FormData()
    };
  },
  created() {
    this.getSheng();
    this.default();
    this.search();
  },
  methods: {
    default() {
      this.queryForm = {
        pageNumber: 1,
        pageSize: 10,
        params: {
          state: '',
          city: '',
          zipCode: '',
          areaType: ''
        }
      };
    },
    reset() {
      this.default();
      this.search1();
    },
    search1() {
      this.queryForm.pageNumber = 1;
      this.search();
    },
    search() {
      zipCodeManagePage(this.queryForm).then(res => {
        if (res.code === 200) {
          this.total = res.data.total;
          this.tableDate = res.data.records;
        }
      });
    },
    tableDel(id) {
      zipCodeManageDel(id).then(res => {
        if (res.code === 200) {
          this.$message.success(this.$t('collectionCenter.DeleteSucceeded'));
          this.search();
        }
      });
    },
    exportAll() {
      const form = this.queryForm.params;
      zipCodeManageExportAll(form).then(res => {
        if (res.code === 200) {
          goRWExportList(this);
        }
      });
    },
    newAdd() {
      this.dialogIsOpen = true;
      this.dialogTitle = this.$t('collectionCenter.add');
    },
    edit(row) {
      this.postalCodeList = {
        id: row.id,
        state: row.state,
        city: row.city,
        zipCodeList: [
          {
            startZipCodeStr: row.startZipCodeStr,
            endZipCodeStr: row.endZipCodeStr,
            areaType: row.areaType
          }
        ],
        version: row.version
      };
      this.dialogIsOpen = true;
      this.dialogTitle = this.$t('collectionCenter.edit');
    },
    addNewRow() {
      this.postalCodeList.zipCodeList.push({
        startZipCodeStr: '',
        endZipCodeStr: '',
        areaType: ''
      });
    },
    removeRow(ind) {
      if (this.postalCodeList.zipCodeList.length > 1) {
        this.postalCodeList.zipCodeList.splice(ind, 1);
      } else {
        this.$message.warning(this.$t('collectionCenter.keepAtLeastOneRow')); // 至少保留一行
      }
    },
    cloceDialog() {
      this.dialogIsOpen = false;
      this.postalCodeList = {
        state: '',
        city: '',
        zipCodeList: [
          { startZipCodeStr: '', endZipCodeStr: '', areaType: '' }
        ]
      };
      this.$refs.formRef.resetFields();
    },
    submit() {
      for (let i = 0; i < this.postalCodeList.zipCodeList.length; i++) {
        const item = this.postalCodeList.zipCodeList[i];
        if (!item.areaType) {
          this.$message.error(`${this.$t('collectionCenter.rowValidationError1')} ${i + 1} ${this.$t('collectionCenter.rowValidationError2')}`);
          return;
        }
      }
      this.$refs.formRef.validate(valid => {
        if (valid) {
          if (this.dialogTitle === this.$t('collectionCenter.add')) {
            const dataToSubmit = {
              state: this.postalCodeList.state,
              city: this.postalCodeList.city,
              zipCodeList: this.postalCodeList.zipCodeList
            };
            zipCodeManageAdd(dataToSubmit).then(res => {
              if (res.code === 200) {
                this.dialogIsOpen = false;
                this.$message.success(this.$t('collectionCenter.addSuccessful')); // '新增成功'
                this.search();
              }
            });
          }
          if (this.dialogTitle === this.$t('collectionCenter.edit')) {
            const dataToSubmit = {
              id: this.postalCodeList.id,
              state: this.postalCodeList.state,
              startZipCodeStr: this.postalCodeList.zipCodeList[0].startZipCodeStr,
              endZipCodeStr: this.postalCodeList.zipCodeList[0].endZipCodeStr,
              areaType: this.postalCodeList.zipCodeList[0].areaType,
              version: this.postalCodeList.version,
              city: this.postalCodeList.city
            };
            zipCodeManageEdit(dataToSubmit).then(res => {
              if (res.code === 200) {
                this.dialogIsOpen = false;
                this.$message.success(this.$t('collectionCenter.ModificationSuccessful'));
                this.search();
              }
            });
          }
        } else {
          this.$message.error(this.$t('collectionCenter.checkFormFields'));
          return false;
        }
      });
    },

    importThis() {
      this.importIsOpen = true;
    },
    cloceImportDialog() {
      this.importIsOpen = false;
      this.importFile = new FormData();
      this.parsedDataList = [];
      if (this.$refs.demoUpload) {
        this.$refs.demoUpload.clearFiles();
      }
    },

    // 解析xlsx
    async parseExcelFile(file) {
      const wb = new ExcelJS.Workbook();
      const parsedData = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = async() => {
          try {
            await wb.xlsx.load(reader.result);

            const worksheet = wb.worksheets[0];
            const data = [];

            const headerMapping = {
              'UF/州': 'state',
              'City/城市': 'city',
              'CEP/起始邮编': 'startZipCode',
              'CEP/结束邮编': 'endZipCode',
              'CAP/INT区域类型': 'areaType'
            };

            worksheet.eachRow((row, rowNumber) => {
              if (rowNumber === 1) return;

              const rowData = {};
              row.eachCell((cell, colNumber) => {
                const originalHeader = worksheet.getRow(1).getCell(colNumber).text;
                const targetField = headerMapping[originalHeader];
                if (targetField) {
                  rowData[targetField] = cell.text || cell.value;
                }
              });

              data.push(rowData);
            });

            resolve(data);
          } catch (e) {
            reject(e);
          }
        };
        reader.onerror = () => {
          reject(new Error(this.$t('collectionCenter.fileReadFailed'))); // '文件读取失败'
        };
        reader.readAsArrayBuffer(file);
      });

      return parsedData;
    },
    // 导入
    async beforeUpload(file) {
      const fileSuffix = file.name.substring(file.name.lastIndexOf('.') + 1);
      const whiteList = ['xlsx'];
      if (whiteList.indexOf(fileSuffix) === -1) {
        // 上传文件只能是xlsx格式
        this.$message.error(this.$t('orderImport.uploadOnlyXlsx'));
        this.$refs.demoUpload.clearFiles();
        this.importFile = new FormData();
        this.parsedDataList = [];
        return false;
      }
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        // 上传文件大小不能超过 10MB
        this.$message.error(this.$t('collectionCenter.uploadNot10MB'));
        this.$refs.demoUpload.clearFiles();
        this.importFile = new FormData();
        this.parsedDataList = [];
        return false;
      }

      let parsedData = [];
      try {
        parsedData = await this.parseExcelFile(file);
        console.log('解析后的数据:', parsedData);

        if (!parsedData || parsedData.length === 0) {
          this.$message.warning(this.$t('collectionCenter.noParsableDataInFile')); // '文件中没有可解析的数据'
          this.$refs.demoUpload.clearFiles();
          this.importFile = new FormData();
          this.parsedDataList = [];
          return false;
        }

        if (parsedData.every(item => Object.keys(item).length === 0)) {
          this.$message.warning(this.$t('collectionCenter.emptyDataParsed')); // '解析到空数据，请检查文件内容是否符合模板'
          this.$refs.demoUpload.clearFiles();
          this.importFile = new FormData();
          this.parsedDataList = [];
          return false;
        }

        // 校验逻辑开始
        const zipRegex = /^[0-9]{8}$/;
        const zipRanges = [];
        for (let i = 0; i < parsedData.length; i++) {
          const row = parsedData[i];
          const rowNumber = i + 1;

          // 必填字段校验
          if (!row.state || !row.city || !row.startZipCode || !row.endZipCode || !row.areaType) {
            //                      `第  行存在空字段，请检查数据完整性`
            this.$message.error(this.$t('collectionCenter.tips1') + rowNumber + this.$t('collectionCenter.tips1_1'));
            this.$refs.demoUpload.clearFiles();
            this.importFile = new FormData();
            this.parsedDataList = [];
            return false;
          }

          // 邮编格式校验
          if (!zipRegex.test(row.startZipCode) || !zipRegex.test(row.endZipCode)) {
            //                     `第  行邮编格式错误，需为8位纯数字`
            this.$message.error(this.$t('collectionCenter.tips1') + rowNumber + this.$t('collectionCenter.tip2'));
            this.$refs.demoUpload.clearFiles();
            this.importFile = new FormData();
            this.parsedDataList = [];
            return false;
          }

          // 起始邮编不能大于结束邮编
          if (row.startZipCode > row.endZipCode) {
            // `第 ${rowNumber} 行起始邮编不能大于结束邮编`
            this.$message.error(this.$t('collectionCenter.tips1') + rowNumber + this.$t('collectionCenter.tip3'));
            this.$refs.demoUpload.clearFiles();
            this.importFile = new FormData();
            this.parsedDataList = [];
            return false;
          }

          // 区域类型校验
          if (row.areaType !== 'CAP' && row.areaType !== 'INT') {
            // `第 ${rowNumber} 行区域类型必须为 CAP 或 INT`
            this.$message.error(this.$t('collectionCenter.tips1') + rowNumber + this.$t('collectionCenter.tip4'));
            this.$refs.demoUpload.clearFiles();
            this.importFile = new FormData();
            this.parsedDataList = [];
            return false;
          }

          // 邮编范围不能重复（内存中校验）
          for (let j = 0; j < zipRanges.length; j++) {
            const existing = zipRanges[j];
            if (
              row.state === existing.state &&
              row.city === existing.city &&
              ((row.startZipCode <= existing.endZipCode && row.endZipCode >= existing.startZipCode) ||
                (existing.startZipCode <= row.endZipCode && existing.endZipCode >= row.startZipCode))
            ) {
              // `第 ${rowNumber} 行与第 ${j + 1} 行邮编范围重叠，请调整`
              this.$message.error(`
                ${this.$t('collectionCenter.tips1')}${rowNumber}
                ${this.$t('collectionCenter.tip5_1')}${j + 1}
                ${this.$t('collectionCenter.tip5_2')}
              `);
              this.$refs.demoUpload.clearFiles();
              this.importFile = new FormData();
              this.parsedDataList = [];
              return false;
            }
          }
        }

        console.log('准备提交的数据:', parsedData);
        this.parsedDataList = parsedData;
        return true;
      } catch (error) {
        this.$message.error(this.$t('collectionCenter.fileParseFailed')); // '文件解析失败'
        this.$refs.demoUpload.clearFiles();
        this.importFile = new FormData();
        this.parsedDataList = [];
        return false;
      }
    },
    async upLoad(option) {
      const lastIndex = option.file.name.lastIndexOf('.');
      const fileType = option.file.name.substring(lastIndex + 1);
      if (fileType === 'xlsx') {
        const files = option.file;
        const formData = new FormData();
        formData.append('file', files);
        this.importFile = formData;
      } else {
        this.importFile = new FormData();
        this.parsedDataList = [];
      }
    },
    submitImportFile() {
      if (this.parsedDataList && this.parsedDataList.length > 0) {
        const load = Loading.service({
          fullscreen: true,
          lock: true,
          spinner: 'el-icon-loading',
          text: this.$t('spareNumberPoo.loading'),
          background: 'rgba(250, 250, 250, 0.6)'
        });
        zipCodeManageImport(this.importFile).then(res => {
          if (res.code === 200) {
            this.$message.success(res.data);
            this.search();
            load.close();
          }
        }).finally(() => {
          load.close();
          this.cloceImportDialog();
        });
      } else {
        this.$message.warning(this.$t('collectionCenter.fileUploadMessage'));
      }
    },
    async templateDownload() {
      const that = this;
      async function ddd() {
        const wb = new ExcelJS.Workbook();
        const Sheet1 = wb.addWorksheet('Sheet1');

        // 定义列结构
        const columns = [
          { header: 'UF/州', key: 'state', width: 20 },
          { header: 'City/城市', key: 'city', width: 25 },
          { header: 'CEP/起始邮编', key: 'startZipCodeStr', width: 20 },
          { header: 'CEP/结束邮编', key: 'endZipCodeStr', width: 20 },
          { header: 'CAP/INT区域类型', key: 'areaType', width: 20 }
        ];

        // 设置列（这会自动创建第一行作为标题）
        Sheet1.columns = columns;

        // 设置表头行样式（必须在 columns 设置之后立即处理）
        const headerRow = Sheet1.getRow(1);
        headerRow.height = 30;
        headerRow.eachCell((cell) => {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: '00b050' } // 背景色 #00b050
          };
          cell.font = {
            color: { argb: '000' }, // 白色字体
            bold: true
          };
          cell.alignment = {
            horizontal: 'center',
            vertical: 'center'
          };
        });

        // 创建下拉选项工作表并填充内容
        const dropdownSheet = wb.addWorksheet('Dropdown');
        dropdownSheet.columns = [{ header: 'Option', key: 'option' }];
        dropdownSheet.addRows([
          { option: 'CAP' },
          { option: 'INT' }
        ]);
        dropdownSheet.state = 'veryHidden'; // 深度隐藏该sheet

        // 给第5列添加下拉数据验证
        for (let i = 2; i <= 1000; i++) {
          Sheet1.getCell(`E${i}`).dataValidation = {
            type: 'list',
            allowBlank: true,
            formulae: [`=Dropdown!$A$2:$A$3`]
          };
        }

        // 写入文件并下载
        const buffer = await wb.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/octet-stream' });
        const fileName = `${that.$t('basicData.zipCode')}-${new Date().getTime()}.xlsx`;

        saveAs(blob, fileName);
      }
      ddd();
    },
    getSheng() {
      const params = {
        pageNumber: 1,
        pageSize: 200,
        params: {
          name: '',
          countryName: 'Brazil'
        }
      };
      selectState(params, false).then((res) => {
        if (res.code === 200) {
          this.twoCodeList = res.data.records;
        }
      });
    },
    getCity() {
      if (this.dialogIsOpen) {
        this.postalCodeList.city = '';
      } else {
        this.queryForm.params.city = '';
      }
      let id = null;
      this.twoCodeList.map((item) => {
        if (this.dialogIsOpen) {
          if (item.shortName === this.postalCodeList.state) {
            id = item.id;
          }
        } else {
          if (item.shortName === this.queryForm.params.state) {
            id = item.id;
          }
        }
      });
      const params = {
        pageNumber: 1,
        pageSize: 200,
        params: {
          id,
          name: ''
        }
      };
      selectCity(params, false).then((res) => {
        if (res.code === 200) {
          this.allCity = res.data.records;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.import-title {
  display: inline-block;
  font-size: 17px;
  font-weight: bold;
  color: #000;
  margin-left: 50px;
  margin-bottom: 20px;
}
.upload-container {
  display: flex;
  justify-content: center;
  align-items: center;
  .upload-demo {
    width: 60%;
  }
}
.upload-container ::v-deep .el-upload-dragger {
  background-color: #f2f3f5;
  border: none;
  height: 110px;
}
::v-deep .el-dialog__title {
  color: #000;
  font-weight: bold;
}
.el-upload__text {
  font-size: 18px;
}
.selectClass ::v-deep .el-form-item__label {
  line-height: 24px !important;
}
.Box ::v-deep .el-divider {
  margin-top: 0 !important;
}
.Box{
  padding: 20px;
  box-sizing: border-box;
}
.right{
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.codeClass {
  color: #cc0000;
  font-size: 12px;
}
.templateDownloadClass {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #409eff;
  background: #f2f3f5;
  width: 70%;
  margin: 0 auto;
  padding: 5px 10px;
  border-radius: 2px;
  box-sizing: border-box;
}
</style>
